import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const title = "Leave a Comment";

const CommentRespond = ({ storyId, onCommentAdded }) => {
    const [comment, setComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!comment.trim()) return;

        setIsSubmitting(true);
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(
                `${process.env.REACT_APP_MAIN_SITE_URL}/story/comment`,
                {
                    story_id: storyId,
                    comment: comment
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            
            setComment('');
            toast.success("Comment added successfully!");
            
            if (onCommentAdded) {
                onCommentAdded(res.data.data || res.data); // Try to pass new comment, or trigger refetch
            }
        } catch (error) {
            console.error("Failed to add comment", error);
            toast.error(error.response?.data?.message || "Failed to add comment");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div id="respond" className="comment-respond">
            <div className="add-comment">
                <div className="widget-title">
                    <h3>{title}</h3>
                </div>
                <form onSubmit={handleSubmit} id="commentform" className="comment-form">
                    <textarea 
                        rows="5" 
                        type="text"
                        id="item04"
                        name="message"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Write your comment here..."
                        required
                    ></textarea>
                    <button className="lab-btn" type="submit" disabled={isSubmitting}>
                        <span>{isSubmitting ? "Sending..." : "Send Comment"}</span>
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CommentRespond;